
import React from "react";
const sizes = {

    text_md_regular: "text-[1.80rem] font-normal sm:text-[0.81rem]",
    body_body___large: "font-sfpro text-[1.00rem] font-normal sm:text-[0.81rem]",
    text_sm_regular: "text-[0.88rem] font-normal",
    body_body_medium: "tracking-[0.0erem] font-sfpro text-[0.88rem] font-normal",
    body_body__large1: "text-[1.0erem] font-normal sm:text-[0.81rem]",
    body_body_body_small: "text-[0.75rem] font-normal",
    body_body_small1: "font-sfpro text-[0.75rem] font-normal",
    textxs: "text-[0.88rem] font-normal",
    texts: "text-[1.0erem] font-normal sm:text-[0.81rem]",
    textmd: "text-[1.13rem] font-light sm:text-[0.94rem]",
};

const Text = ({ children, className = "", as, size = "body_body_____medium", ...restProps }) => {
    const Component = as || "p";
    return (
        <Component className={`text-white-a700 font-sfpro ${className} ${sizes[size]} `} {...restProps}>
            {children}
        </Component>
    );
};
export { Text };